import Radio from "../../../../../../packages/design-system/src/Radio";
import * as React from 'react';
export default {
  Radio,
  React
};